import { MoreHorizontal } from "lucide-react";

type ActionOption = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode; // ✅ optional icon
  className?: string;
};

const ActionMenu = ({ options }: { options: ActionOption[] }) => {
  return (
    <div className="dropdown dropdown-click">
      {/* ✅ 3 dots button */}
      <button
        className="btn-link border-0 bg-transparent p-0"
        data-toggle="dropdown"
      >
        <MoreHorizontal size={20} />
      </button>

      {/* ✅ Dropdown items */}
      <div className="dropdown-menu dropdown-bottomLeft dropdown-menu-right">
        {options.map((item, idx) => (
          <div
            key={idx}
            className={`dropdown-item d-flex align-items-center ${
              item.className || ""
            }`}
            onClick={item.onClick}
            style={{ cursor: "pointer" }}
          >
            {/* ✅ Icon (if provided) */}
            {item.icon && <span className="mr-2">{item.icon}</span>}

            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActionMenu;
